<template>
  <v-dialog
    :max-width="isMobile ? '500' : '700'"
    v-model="isModalOpen"
  >
    <v-layout class="starting_modal">
      <div v-if="isDesktop" class="picture">
        <img
          alt="start modal picture"
          src="assets/start-modal-picture.svg"
        />
      </div>
      <v-card class="starting_modal__right_part">
        <v-card-title class="d-flex justify-end">
          <v-btn class="close_icon">
            <v-icon
              size="16"
              color="white"
              @click.native="closeModal"
            >mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p class="black--text">{{ $t('starting-modal.note') }}</p>
          <p class="black--text title">{{ $t('starting-modal.title') }}</p>

          <div
            class="advice d-flex flex-nowrap mt-2"
            v-for="advice in advices"
            :key="advice.imagePath"
          >
            <img
              alt="upload icon"
              :src="advice.imagePath"
            />
            <p class="black--text">{{ $t(advice.text) }}</p>
          </div>
        </v-card-text>
        <v-card-actions class="pl-4">
          <v-btn
            class="primary_button mb-2"
            @click.native="closeModal"
          >{{ $t('starting-modal.button') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-dialog>
</template>

<script>
const ADVICES = [
  {
    imagePath: "assets/icons/starting-modal/first-advice-icon.svg",
    text: "starting-modal.first-advice"
  },
  {
    imagePath: "assets/icons/starting-modal/second-advice-icon.svg",
    text: "starting-modal.second-advice"
  },
  {
    imagePath: "assets/icons/starting-modal/third-advice-icon.svg",
    text: "starting-modal.third-advice"
  },
  {
    imagePath: "assets/icons/starting-modal/fourth-advice-icon.svg",
    text: "starting-modal.fourth-advice"
  },
]

export default {
  name: "StartingModal",
  data() {
    return {
      isModalOpen: false,
      advices: ADVICES
    }
  },
  methods: {
    closeModal() {
      this.isModalOpen = false
    }
  }
}
</script>
